import { twMerge } from "tailwind-merge";
import { PageContainer } from "../../../../components/pageContainer/PageContainer";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H5,
  H6,
} from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import { Icon } from "../../../../components";
import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import { BUSINESS_INTEGRATION_SETTINGS } from "../../../../constants/routes";
import { useQuickbooksCustomers } from "../../../../hooks/api/v2/quickbooks/useQuickbooksCustomers";
import { useSupplierUpdate } from "../../../../hooks/api/v2/supplier/useSupplierUpdate";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { IntegrationUpdateContacts } from "./IntegrationUpdateContacts";
import { SharedIntegrationConfirmContent } from "./SharedIntegrationConfirmContent";
//
export const IntegrationConfirmQuickbooks = (): ReactElement => {
  const navigate = useNavigate();
  const { business } = useSellarCurrentBusiness();
  const updateSupplierMutation = useSupplierUpdate(business?.Supplier?.id ?? 0);
  const quickbooksCustomerMutation = useQuickbooksCustomers();
  const [updateQuickbooksContacts, setUpdateQuickbooksContacts] =
    useState<boolean>();
  const quickbooksContactsFromBusiness =
    business?.Supplier?.updateQuickbooksContacts;
  const [previousQuickbooksContacts, setPreviousQuickbooksContacts] = useState(
    quickbooksContactsFromBusiness,
  );
  if (quickbooksContactsFromBusiness !== previousQuickbooksContacts) {
    setPreviousQuickbooksContacts(quickbooksContactsFromBusiness);
    setUpdateQuickbooksContacts(quickbooksContactsFromBusiness);
  }
  const oAuth2Url = `https://appcenter.intuit.com/connect/oauth2?client_id=${
    import.meta.env.VITE_QUICKBOOKS_CLIENT_ID
  }&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=${
    import.meta.env.VITE_URL
  }/business/settings/integrations&state=Quickbooks`;

  //
  return (
    <>
      <NavigationBar
        title={"Quickbooks"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => navigate(BUSINESS_INTEGRATION_SETTINGS)}
      />
      <PageContainer>
        <SharedIntegrationConfirmContent
          integrationType={"quickbooks"}
          oAuth2Url={oAuth2Url}
        />
        <Card className="bg-white">
          <CardContent className={"flex flex-wrap justify-between gap-2 p-4"}>
            <div className="flex flex-col">
              <H5>Export your customer list from Quickbooks</H5>
              <H6>
                Use this option if you are looking to import your customers into
                Sellar.
              </H6>
            </div>
            <Button
              color={"secondary"}
              loading={quickbooksCustomerMutation.isPending}
              onClick={() =>
                quickbooksCustomerMutation.mutate(undefined, {
                  onSuccess: (csvData) => {
                    const blob = new Blob(["\ufeff", csvData]);
                    const downloadLink = document.createElement("a");
                    const fileName = `Customers.csv`;
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = fileName;
                    downloadLink.click();
                    downloadLink.remove();
                  },
                })
              }
            >
              <Icon icon={"DOWNLOAD"} /> Export
            </Button>
          </CardContent>
        </Card>
        <Card className="bg-white">
          <CardHeader className={twMerge("bg-white", "flex flex-col p-4")}>
            <H5>Settings</H5>
            <H6>Configure how you would like this integration to work</H6>
          </CardHeader>
          <IntegrationUpdateContacts
            updateContacts={updateQuickbooksContacts}
            onChange={(e) => {
              updateSupplierMutation.mutate(
                {
                  updateQuickbooksContacts: e.currentTarget.value === "yes",
                },
                {
                  onSuccess: () =>
                    setUpdateQuickbooksContacts(
                      e.currentTarget.value === "yes",
                    ),
                },
              );
            }}
            integrationType={"Quickbooks"}
          />
        </Card>
      </PageContainer>
    </>
  );
};
